import { CustomQuestionVisibility } from 'src/graphql/types/customQuestions'

interface QuestionResponseLike {
  templateQuestion?: {
    visibility?: CustomQuestionVisibility | string | null
  } | null
}

/**
 * PUBLIC template questions belong to the public short form only — the
 * driver-facing DOT application must neither display nor require them.
 * The `Application.questionResponses` GraphQL relation is shared with the
 * recruiter card (which shows all responses), so the DOT application
 * filters client-side to PRIVATE questions.
 *
 * Responses missing a visibility (e.g. stale cache entries) are kept so a
 * legitimate DOT question is never silently hidden.
 */
export const filterPrivateQuestionResponses = <T extends QuestionResponseLike>(
  questionResponses: T[] | null | undefined
): T[] => {
  if (!questionResponses) {
    return []
  }
  return questionResponses.filter(
    (response) =>
      response?.templateQuestion?.visibility !== CustomQuestionVisibility.PUBLIC
  )
}
